export default __webpack_public_path__ + "img/0a3d6603d53a99b0e64bada6933c0c05.svg";